import React from 'react'

import {SideDrawerBlackBack} from './BackdropStyle'

const Backdrop = ({onClick}) => (
  <SideDrawerBlackBack onClick={onClick}/>
)

export default Backdrop